<script>
import Dialog from '@/components/general/dialog.vue'

export default {
  components: { Dialog },

  props: {
    preview: {
      type: Object,
      default: () => {},
    },
    warnings: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {
      overlay: '',
      resolving: {},
      noTitle: 'No Release Title available',
      noDescription: 'No Release Description available',
      baseUrl: 'https://anzuk.visualstudio.com/Staffroom/_workitems/edit/',
      overlayActions: [
        {
          title: 'Edit',
          icon: 'mdi-pencil',
          bgColour: 'primary',
          iconColour: 'White',
          action: (wi) => {
            this.openResolve(wi)
          },
        },
        {
          title: 'View in Azure',
          icon: 'mdi-open-in-new',
          bgColour: 'primary',
          iconColour: 'primary',
          action: ({ id }) => {
            this.goToWorkItem(id)
          },
        },
        {
          title: 'Remove',
          bgColour: 'error',
          icon: '',
          action: ({ id }) => {
            this.removeFromPreview(id)
          },
        },
      ],
    }
  },

  methods: {
    openResolve(wi) {
      this.resolving = { ...wi }
      this.$refs.resolveDialog.open()
    },
    resolveWorkItem() {
      this.$emit('update-work-item', this.resolving)
      this.resolving = {}
      this.$refs.resolveDialog.close()
    },
    goToWorkItem(id) {
      window.open(`${this.baseUrl}${id}/`, '_blank')
    },
    removeFromPreview(id) {
      const { preview } = this.$store.state.releases
      const { releaseData } = preview || {}
      const { workItems } = releaseData || []

      if (workItems?.length) {
        const filteredWorkItems = workItems.filter((item) => item.id !== id)
        this.$store.commit('releases/SET_STATE', {
          key: 'preview',
          value: {
            ...preview,
            releaseData: {
              ...releaseData,
              workItems: filteredWorkItems,
            },
          },
        })
      }
    },
  },
}
</script>

<template>
  <div class="warnings-grid">
    <v-card
      v-for="wi in warnings"
      :key="wi.id"
      class="pa-4 mb-2 warnings d-flex flex-column justify-space-between position-relative"
      @mouseover="() => (overlay = wi.id)"
      @mouseleave="() => (overlay = '')"
    >
      <transition name="fade-in">
        <div
          v-if="overlay === wi.id"
          class="warning-overlay d-flex justify-center align-center"
        >
          <v-btn
            v-for="(
              { title, bgColour, iconColour, icon, action }, index
            ) in overlayActions"
            :key="title"
            :color="bgColour"
            depressed
            :outlined="index === 1"
            :text="index > 1"
            class="pa-2 mr-4 text-body-1 flex justify-center items-center hover"
            @click="action(wi)"
          >
            <v-icon
              v-if="icon.length"
              class="mr-2"
              medium
              :color="iconColour"
              >{{ icon }}</v-icon
            >
            {{ title }}
          </v-btn>
        </div>
      </transition>
      <div>
        <p class="font-weight-bold">{{ wi.id }} - {{ wi.author }}</p>
        <p class="mt-4 mr-4">{{ wi.title }}</p>
      </div>
      <v-chip-group column>
        <v-chip
          v-if="wi.releaseDescription === noDescription"
          key="0"
          class="warning-chip"
        >
          <span class="mr-2">
            <v-icon color="rgb(201, 120, 0)">mdi-alert-circle-outline</v-icon>
          </span>
          Release Description</v-chip
        >
        <v-chip v-if="wi.releaseTitle === noTitle" key="1" class="warning-chip">
          <span class="mr-2">
            <v-icon color="rgb(201, 120, 0)">mdi-alert-circle-outline</v-icon>
          </span>
          Release Title</v-chip
        >
      </v-chip-group>
    </v-card>

    <!-- resolve work item data dialog -->

    <Dialog
      ref="resolveDialog"
      title="Resolve Work Item"
      action-title="Resolve"
      :action="resolveWorkItem"
    >
      <template v-slot:content>
        <div v-if="resolving.id">
          <p
            class="mb-8 text-h6 text-center work-item-link"
            @click="goToWorkItem(resolving.id)"
            ><span class="font-weight-bold">{{ resolving.id }} - </span
            >{{ resolving.title }}</p
          >
          <div class="mb-4">
            <p class="font-weight-bold mb-1">Release Title</p>
            <v-text-field v-model="resolving.releaseTitle"></v-text-field>
          </div>
          <div class="mb-4">
            <p class="font-weight-bold">Release Description</p>
            <v-textarea
              v-model="resolving.releaseDescription"
              outlined
            ></v-textarea>
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<style lang="scss" scoped>
.warning-chip {
  color: rgb(201, 120, 0);
  background-color: rgb(253, 222, 165) !important;
}

.warning-overlay {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: rgba(247, 248, 254, 0.9);
}
.work-item-link:hover {
  text-decoration: underline !important;
  cursor: pointer !important;
}

.fade-in-enter-active,
.fade-in-leave-active {
  transition: opacity 0.5s;
}
.fade-in-enter, .fade-in-leave-to /* .fade-up-leave-active in <2.1.8 */ {
  opacity: 0;
}

.warnings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  grid-auto-flow: row;
  width: 100%;
  gap: 20px;
}
</style>
